'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDisplayName;
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}


//////////////////
// WEBPACK FOOTER
// ./~/react-display-name/lib/getDisplayName.js
// module id = 983
// module chunks = 4